import React, { useEffect, useState } from 'react';

export default function AddressPickerModal({ open, onClose, lat, lng, address, onPick }) {
  const [local, setLocal] = useState({ lat: lat || '', lng: lng || '', address: address || '' });

  useEffect(() => {
    setLocal({ lat: lat || '', lng: lng || '', address: address || '' });
  }, [lat, lng, address]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-3xl rounded-xl bg-white shadow-xl">
        <div className="flex items-center justify-between border-b px-6 py-4">
          <h3 className="text-lg font-semibold">Address</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <i className="fa-regular fa-circle-xmark text-xl" />
          </button>
        </div>

        {/* “Search” input to mirror your reference UI  */}
        <div className="px-6 pt-5">
          <div className="flex items-center gap-2">
            <div className="relative w-full">
              <i className="fa-solid fa-magnifying-glass absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                className="w-full rounded-lg border px-10 py-2"
                placeholder="Enter a location"
                value={local.address}
                onChange={(e) => setLocal((s) => ({ ...s, address: e.target.value }))}
              />
            </div>

            {/* Settings / placeholder icon, for parity with screenshot */}
            <button
              type="button"
              className="inline-flex h-[38px] w-[38px] items-center justify-center rounded-lg border text-gray-600 hover:bg-gray-50"
              title="Options"
            >
              <i className="fa-solid fa-gear" />
            </button>
          </div>
        </div>

        {/* Map placeholder area (safe without Google Maps) */}
        <div className="mx-6 my-4 h-80 overflow-hidden rounded-lg border">
          <div className="flex h-full items-center justify-center bg-gray-100 text-gray-500">
            <div className="text-center">
              <i className="fa-solid fa-location-dot text-3xl" />
              <p className="mt-2 text-sm">
                Map preview (optional). Enter lat/lng below or integrate Google Maps later.
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-4 px-6 pb-5 md:grid-cols-3">
          <label className="block">
            <span className="mb-1 block text-sm font-medium text-gray-700">Latitude</span>
            <input
              className="db-field"
              value={local.lat}
              onChange={(e) => setLocal((s) => ({ ...s, lat: e.target.value }))}
              placeholder="e.g. 23.8103"
            />
          </label>
          <label className="block">
            <span className="mb-1 block text-sm font-medium text-gray-700">Longitude</span>
            <input
              className="db-field"
              value={local.lng}
              onChange={(e) => setLocal((s) => ({ ...s, lng: e.target.value }))}
              placeholder="e.g. 90.4125"
            />
          </label>
          <div className="flex items-end">
            <a
              className="inline-flex w-full items-center justify-center rounded-lg border px-3 py-2 text-sm text-blue-600 hover:bg-blue-50"
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(local.address || '')}`}
              target="_blank" rel="noreferrer"
            >
              Open in Google Maps
            </a>
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 border-t px-6 py-4">
          <button onClick={onClose} className="db-btn bg-gray-100 text-gray-700">
            Close
          </button>
          <button
            onClick={() => onPick(local)}
            className="db-btn bg-primary text-white shadow-[0px_6px_10px_rgba(23,_114,_255,_0.24)]"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
